var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 493.5 493.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m246.75,0C115.54,0,7.96,102.94.42,232.25c-.28,4.79-.42,9.64-.42,14.5,0,136.07,110.69,246.79,246.75,246.79s239.57-103.68,246.4-233.69c.25-4.33.35-8.7.35-13.1C493.5,110.72,382.82,0,246.75,0Zm125.42,260.07l-.04,64.36-126.16,70.09-126.34-69.92.1-90.56.07-62.93,126.1-70.09,126.33,69.92-.06,89.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderlogo);
export default __webpack_public_path__ + "static/media/headerlogo.070c6f6483fbd6b5dfd76361859815bc.svg";
export { ForwardRef as ReactComponent };